import { memo } from 'react'
import './styles.css'
import iconChevronLeft from '../../assets/icons/chevron-left-paginator.svg'
import iconChevronRight from '../../assets/icons/chevron-right-paginator.svg'

const Pagination = memo(function Pagination({
  currentPage = 1,
  totalPages = 1,
  onPageChange
}) {
  const pages = []
  const maxVisible = 4
  let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2))
  let endPage = Math.min(totalPages, startPage + maxVisible - 1)

  if (endPage - startPage < maxVisible - 1) {
    startPage = Math.max(1, endPage - maxVisible + 1)
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i)
  }

  return (
    <div className="pagination">
      <button
        className="pagination-button pagination-button--nav"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <img src={iconChevronLeft} alt="Anterior" className="pagination-icon" />
      </button>
      {pages.map((page) => (
        <button
          key={page}
          className={`pagination-button ${currentPage === page ? 'pagination-button--active' : ''}`}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}
      <button
        className="pagination-button pagination-button--nav"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <img src={iconChevronRight} alt="Siguiente" className="pagination-icon" />
      </button>
    </div>
  )
})

export default Pagination
